<template>
    <div class='hsx-win-menu flex-wrap flex-between'>
      <div class="flex-wrap">
        <template v-for="item in items.filter(v=>!v.right)">
          <div class='hsx-win-menu-item' :class="{'hsx-win-menu-item-selected':active==item.key}" :key="item.key" @click="$emit('event',item.key)">
          <BaseIcon :icon="item.icon" style="margin-right:5px;" v-if="item.icon" />{{item.name}}
        </div>
        </template>
      </div>
      <div class="flex-wrap">
        <template v-for="item in items.filter(v=>v.right)">
          <div class='hsx-win-menu-item' :key="item.key" @click="$emit('event',item.key)">
            <BaseIcon :icon="item.icon" style="margin-right:5px;" v-if="item.icon" />{{item.name}}
        </div>
        </template>
      </div>
    </div>
  </template>

<script>
export default {
  props: ['items', 'active'],
};
</script>

  <style lang="less" scoped>
  .hsx-win-menu{
    background:var(--bg2);
    color:var(--text2);
    position: relative;
    display: flex;
    font-size:12px;
    align-items: center;
    .hsx-win-menu-item{
      height:100%;
      min-width: 50px;
      height:25px;
      display: flex;
      align-items: center;
      padding:0 10px;
      justify-content: center;
    }

    .hsx-win-menu-item:hover{
      filter:brightness(1.1);
      cursor: pointer;
      background:var(--primary);
      color:var(--hover-text);
    }

    .hsx-win-menu-item-selected{
      color:var(--primary);
      font-weight: bold;
      background:#00000022;
    }
  }
  </style>
